import pixels from '@/api/pixels'
import helpers from '@/utils/helpers'

const state = {
  rows: [],
  fromPanel: false,
  loading: false,
  error: null,
}

const mutations = {
  SET_ROWS(state, rows) {
    state.rows = rows
  },
  SET_FROM_PANEL(state, fromPanel) {
    state.fromPanel = fromPanel
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
}

const actions = {
  async fetchPixels({ commit }, params) {
    commit('SET_LOADING', true)
    return await pixels
      .fetchPixels(params)
      .then((response) => {
        commit('SET_ROWS', response.data.data?.rows || [])
        commit('SET_FROM_PANEL', Boolean(response.data.data?.pixel_from_panel))
        commit('SET_LOADING', false)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
      })
  },

  async savePixels({ commit }, payload) {
    commit('SET_LOADING', true)
    return await pixels
      .savePixels(payload)
      .then((response) => {
        commit('SET_ROWS', response.data.data?.rows || [])
        commit('SET_FROM_PANEL', Boolean(response.data.data?.pixel_from_panel))
        commit('SET_LOADING', false)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
        throw error
      })
  },

  async testPixel(_, payload) {
    return await pixels
      .testPixel(payload)
      .then((response) => response.data.data)
  },

  async fetchHistory(_, params) {
    return await pixels
      .fetchHistory(params)
      .then((response) => response.data.data?.history || [])
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
